// const initState = {
//     items: [
//         {id:1,title:'Winter body', desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, ex.", price:110,img:'https://via.placeholder.com/220'},
//         {id:2,title:'Adidas', desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, ex.", price:80,img: 'https://via.placeholder.com/220'},
//         {id:3,title:'Vans', desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, ex.",price:120,img: 'https://via.placeholder.com/220'},
//         {id:4,title:'White', desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, ex.", price:260,img:'https://via.placeholder.com/220'},
//         {id:5,title:'Cropped-sho', desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, ex.", price:160,img: 'https://via.placeholder.com/220'},
//         {id:6,title:'Blues', desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima, ex.",price:90,img: 'https://via.placeholder.com/220'}
//     ],
//     addedItems:[],
//     total: 0

// }

const initState = {
    items: [{
        id: 1,
        name: 'T shirt 1',
        price: 70,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 2,
        name: 'T shirt 2',
        price: 40,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 3,
        name: 'T shirt 3',
        price: 20,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 4,
        name: 'T shirt 4',
        price: 130,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    }],
    addedItems:[],
    total: 0
};

const cartReducer= (state = initState,action)=>{
    
    if(action.type === 'ADD_TO_CART'){
        let addedItem = state.items.find(item=> item.id === action.id)
        let existed_item= state.addedItems.find(item=> action.id === item.id)
         if(existed_item)
         {
            addedItem.quantity += 1 
             return{
                ...state,
                 total: state.total + addedItem.price 
                  }
        }
         else{
            addedItem.quantity = 1;
            //calculating the total
            let newTotal = state.total + addedItem.price 
            
            return{
                ...state,
                addedItems: [...state.addedItems, addedItem],
                total : newTotal
            }
            
        }
    }

    if(action.type === 'REMOVE_FROM_CART'){
        let removeItem = state.addedItems.find(item=> action.id === item.id)
        let new_items = state.addedItems.filter(item=> action.id !== item.id)
        console.log(state.addedItems)
        return{
            ...state,
            addedItems: new_items,
            total: state.total - (removeItem.price * removeItem.quantity)
        }
    }



}
export default cartReducer;